'use strict';
var equal = require('ajv/lib/compile/equal');
var validate = (function() {
  var refVal = [];
  var refVal1 = (function() {
    return function validate(data, dataPath, parentData, parentDataProperty, rootData) {
      'use strict';
      var vErrors = null;
      var errors = 0;
      if ((data && typeof data === "object" && !Array.isArray(data))) {
        var errs__0 = errors;
        var valid1 = true;
        for (var key0 in data) {
          var isAdditional0 = !(false || key0 == 'type' || key0 == 'children');
          if (isAdditional0) {
            valid1 = false;
            var err = {
              keyword: 'additionalProperties',
              dataPath: (dataPath || '') + "",
              schemaPath: '#/additionalProperties',
              params: {
                additionalProperty: '' + key0 + ''
              },
              message: 'should NOT have additional properties'
            };
            if (vErrors === null) vErrors = [err];
            else vErrors.push(err);
            errors++;
          }
        }
        var data1 = data.type;
        if (data1 !== undefined) {
          var errs_1 = errors;
          if (typeof data1 !== "string") {
            var err = {
              keyword: 'type',
              dataPath: (dataPath || '') + '.type',
              schemaPath: '#/properties/type/type',
              params: {
                type: 'string'
              },
              message: 'should be string'
            };
            if (vErrors === null) vErrors = [err];
            else vErrors.push(err);
            errors++;
          }
          var schema1 = validate.schema.properties.type.const;
          var valid1 = equal(data1, schema1);
          if (!valid1) {
            var err = {
              keyword: 'const',
              dataPath: (dataPath || '') + '.type',
              schemaPath: '#/properties/type/const',
              params: {
                allowedValue: schema1
              },
              message: 'should be equal to constant'
            };
            if (vErrors === null) vErrors = [err];
            else vErrors.push(err);
            errors++;
          }
          var valid1 = errors === errs_1;
        }
        var data1 = data.children;
        if (data1 === undefined) {
          valid1 = false;
          var err = {
            keyword: 'required',
            dataPath: (dataPath || '') + "",
            schemaPath: '#/required',
            params: {
              missingProperty: 'children'
            },
            message: 'should have required property \'children\''
          };
          if (vErrors === null) vErrors = [err];
          else vErrors.push(err);
          errors++;
        } else {
          var errs_1 = errors;
          if (typeof data1 === "number") {
            if (data1 < 1 || data1 !== data1) {
              var err = {
                keyword: 'minimum',
                dataPath: (dataPath || '') + '.children',
                schemaPath: '#/properties/children/minimum',
                params: {
                  comparison: '>=',
                  limit: 1,
                  exclusive: false
                },
                message: 'should be >= 1'
              };
              if (vErrors === null) vErrors = [err];
              else vErrors.push(err);
              errors++;
            }
          }
          if (Array.isArray(data1)) {
            var errs__1 = errors;
            var valid1;
            for (var i1 = 0; i1 < data1.length; i1++) {
              var data2 = data1[i1];
              var errs_2 = errors;
              var errs_3 = errors;
              if ((data2 && typeof data2 === "object" && !Array.isArray(data2))) {
                var errs__3 = errors;
                var valid4 = true;
                for (var key3 in data2) {
                  var isAdditional3 = !(false || key3 == 'type' || key3 == 'heading' || key3 == 'children');
                  if (isAdditional3) {
                    valid4 = false;
                    var err = {
                      keyword: 'additionalProperties',
                      dataPath: (dataPath || '') + '.children[' + i1 + ']',
                      schemaPath: '#/definitions/group/additionalProperties',
                      params: {
                        additionalProperty: '' + key3 + ''
                      },
                      message: 'should NOT have additional properties'
                    };
                    if (vErrors === null) vErrors = [err];
                    else vErrors.push(err);
                    errors++;
                  }
                }
                var data3 = data2.type;
                if (data3 !== undefined) {
                  var errs_4 = errors;
                  if (typeof data3 !== "string") {
                    var err = {
                      keyword: 'type',
                      dataPath: (dataPath || '') + '.children[' + i1 + '].type',
                      schemaPath: '#/definitions/group/properties/type/type',
                      params: {
                        type: 'string'
                      },
                      message: 'should be string'
                    };
                    if (vErrors === null) vErrors = [err];
                    else vErrors.push(err);
                    errors++;
                  }
                  var schema4 = refVal2.properties.type.const;
                  var valid4 = equal(data3, schema4);
                  if (!valid4) {
                    var err = {
                      keyword: 'const',
                      dataPath: (dataPath || '') + '.children[' + i1 + '].type',
                      schemaPath: '#/definitions/group/properties/type/const',
                      params: {
                        allowedValue: schema4
                      },
                      message: 'should be equal to constant'
                    };
                    if (vErrors === null) vErrors = [err];
                    else vErrors.push(err);
                    errors++;
                  }
                  var valid4 = errors === errs_4;
                }
                var data3 = data2.heading;
                if (data3 !== undefined) {
                  var errs_4 = errors;
                  if (typeof data3 !== "string" && data3 !== null) {
                    var err = {
                      keyword: 'type',
                      dataPath: (dataPath || '') + '.children[' + i1 + '].heading',
                      schemaPath: '#/definitions/group/properties/heading/type',
                      params: {
                        type: 'string,null'
                      },
                      message: 'should be string,null'
                    };
                    if (vErrors === null) vErrors = [err];
                    else vErrors.push(err);
                    errors++;
                  }
                  var valid4 = errors === errs_4;
                }
                var data3 = data2.children;
                if (data3 === undefined) {
                  valid4 = false;
                  var err = {
                    keyword: 'required',
                    dataPath: (dataPath || '') + '.children[' + i1 + ']',
                    schemaPath: '#/definitions/group/required',
                    params: {
                      missingProperty: 'children'
                    },
                    message: 'should have required property \'children\''
                  };
                  if (vErrors === null) vErrors = [err];
                  else vErrors.push(err);
                  errors++;
                } else {
                  var errs_4 = errors;
                  if (Array.isArray(data3)) {
                    if (data3.length < 1) {
                      var err = {
                        keyword: 'minItems',
                        dataPath: (dataPath || '') + '.children[' + i1 + '].children',
                        schemaPath: '#/definitions/group/properties/children/minItems',
                        params: {
                          limit: 1
                        },
                        message: 'should NOT have fewer than 1 items'
                      };
                      if (vErrors === null) vErrors = [err];
                      else vErrors.push(err);
                      errors++;
                    }
                  } else {
                    var err = {
                      keyword: 'type',
                      dataPath: (dataPath || '') + '.children[' + i1 + '].children',
                      schemaPath: '#/definitions/group/properties/children/type',
                      params: {
                        type: 'array'
                      },
                      message: 'should be array'
                    };
                    if (vErrors === null) vErrors = [err];
                    else vErrors.push(err);
                    errors++;
                  }
                  var valid4 = errors === errs_4;
                }
              } else {
                var err = {
                  keyword: 'type',
                  dataPath: (dataPath || '') + '.children[' + i1 + ']',
                  schemaPath: '#/definitions/group/type',
                  params: {
                    type: 'object'
                  },
                  message: 'should be object'
                };
                if (vErrors === null) vErrors = [err];
                else vErrors.push(err);
                errors++;
              }
              var valid3 = errors === errs_3;
              var valid2 = errors === errs_2;
            }
          } else {
            var err = {
              keyword: 'type',
              dataPath: (dataPath || '') + '.children',
              schemaPath: '#/properties/children/type',
              params: {
                type: 'array'
              },
              message: 'should be array'
            };
            if (vErrors === null) vErrors = [err];
            else vErrors.push(err);
            errors++;
          }
          var valid1 = errors === errs_1;
        }
      } else {
        var err = {
          keyword: 'type',
          dataPath: (dataPath || '') + "",
          schemaPath: '#/type',
          params: {
            type: 'object'
          },
          message: 'should be object'
        };
        if (vErrors === null) vErrors = [err];
        else vErrors.push(err);
        errors++;
      }
      validate.errors = vErrors;
      return errors === 0;
    };
  })();
  refVal1.schema = {
    "type": "object",
    "additionalProperties": false,
    "required": ["children"],
    "properties": {
      "type": {
        "type": "string",
        "const": "table"
      },
      "children": {
        "type": "array",
        "minimum": 1,
        "items": {
          "$ref": "#/definitions/group"
        }
      }
    }
  };
  refVal1.errors = null;
  refVal[1] = refVal1;
  var refVal2 = {
    "type": "object",
    "additionalProperties": false,
    "required": ["children"],
    "properties": {
      "type": {
        "type": "string",
        "const": "group"
      },
      "heading": {
        "type": ["string", "null"]
      },
      "children": {
        "type": "array",
        "minItems": 1
      }
    }
  };
  refVal[2] = refVal2;
  return function validate(data, dataPath, parentData, parentDataProperty, rootData) {
    'use strict'; /*# sourceURL=invoicing-items.json */
    var vErrors = null;
    var errors = 0;
    if (rootData === undefined) rootData = data;
    if (Array.isArray(data)) {
      if (data.length < 1) {
        var err = {
          keyword: 'minItems',
          dataPath: (dataPath || '') + "",
          schemaPath: '#/minItems',
          params: {
            limit: 1
          },
          message: 'should NOT have fewer than 1 items'
        };
        if (vErrors === null) vErrors = [err];
        else vErrors.push(err);
        errors++;
      }
      var errs__0 = errors;
      var valid0;
      for (var i0 = 0; i0 < data.length; i0++) {
        var errs_1 = errors;
        var errs__1 = errors;
        var valid1 = false;
        var errs_2 = errors;
        if (!refVal1(data[i0], (dataPath || '') + '[' + i0 + ']', data, i0, rootData)) {
          if (vErrors === null) vErrors = refVal1.errors;
          else vErrors = vErrors.concat(refVal1.errors);
          errors = vErrors.length;
        }
        var valid2 = errors === errs_2;
        valid1 = valid1 || valid2;
        if (!valid1) {
          var err = {
            keyword: 'anyOf',
            dataPath: (dataPath || '') + '[' + i0 + ']',
            schemaPath: '#/items/anyOf',
            params: {},
            message: 'should match some schema in anyOf'
          };
          if (vErrors === null) vErrors = [err];
          else vErrors.push(err);
          errors++;
        } else {
          errors = errs__1;
          if (vErrors !== null) {
            if (errs__1) vErrors.length = errs__1;
            else vErrors = null;
          }
        }
        var valid1 = errors === errs_1;
      }
    } else {
      var err = {
        keyword: 'type',
        dataPath: (dataPath || '') + "",
        schemaPath: '#/type',
        params: {
          type: 'array'
        },
        message: 'should be array'
      };
      if (vErrors === null) vErrors = [err];
      else vErrors.push(err);
      errors++;
    }
    if ((data && typeof data === "object" && !Array.isArray(data))) {
      var errs__0 = errors;
      var valid1 = true;
      for (var key0 in data) {
        valid1 = false;
        var err = {
          keyword: 'additionalProperties',
          dataPath: (dataPath || '') + "",
          schemaPath: '#/additionalProperties',
          params: {
            additionalProperty: '' + key0 + ''
          },
          message: 'should NOT have additional properties'
        };
        if (vErrors === null) vErrors = [err];
        else vErrors.push(err);
        errors++;
      }
    }
    validate.errors = vErrors;
    return errors === 0;
  };
})();
validate.schema = {
  "$schema": "http://json-schema.org/draft-07/schema",
  "$id": "invoicing-items.json",
  "definitions": {
    "group": {
      "type": "object",
      "additionalProperties": false,
      "required": ["children"],
      "properties": {
        "type": {
          "type": "string",
          "const": "group"
        },
        "heading": {
          "type": ["string", "null"]
        },
        "children": {
          "type": "array",
          "minItems": 1
        }
      }
    },
    "table": {
      "type": "object",
      "additionalProperties": false,
      "required": ["children"],
      "properties": {
        "type": {
          "type": "string",
          "const": "table"
        },
        "children": {
          "type": "array",
          "minimum": 1,
          "items": {
            "$ref": "#/definitions/group"
          }
        }
      }
    }
  },
  "type": "array",
  "minItems": 1,
  "items": {
    "anyOf": [{
      "$ref": "#/definitions/table"
    }]
  },
  "additionalProperties": false
};
validate.errors = null;
module.exports = validate;